const MENU_SCRAPING_JOB_STATUSES = {
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  ABORTED: 'ABORTED',
  FAILED: 'FAILED',
}

export default MENU_SCRAPING_JOB_STATUSES
